import React from 'react';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {TextField} from "@mui/material";
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import {ruRU} from '@mui/x-date-pickers/locales';
import {Box} from "@mui/system";
import DateTimeUtil from "../../../utils/common/DateTimeUtil";

const OrderDatePicker = ({
                             label,
                             placeholder,
                             date,
                             field,
                             setDate,
                             validationError,
                             setValidationState,
                             margin = "normal",
                             height = 67
                         }) => {
    const onChange = (e) => {
        if (validationError) {
            setValidationState((errors) => {
                return {...errors, [field]: ""}
            })
        }
        setDate(DateTimeUtil.convertToJavaDate(e))
    }
    return (
        <Box height={height}>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='ru'
                localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                <DatePicker
                    sx={{width: "100%"}}
                    slotProps={{
                        textField: {
                            size: 'small', margin: margin, width: "100%", height: height,
                            variant: 'outlined',
                            error: !!validationError,
                            helperText: validationError,
                            placeholder,
                        },
                        actionBar: {
                            actions: ['clear', 'today'],
                        },
                    }}
                    onAccept={(newDate) => {
                        setDate(DateTimeUtil.convertToJavaDate(newDate));
                    }}
                    label={label}
                    onChange={onChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                        />
                    )}
                    value={date ? dayjs(date) : null}
                />
            </LocalizationProvider>
        </Box>
    );
};

export default OrderDatePicker;
